import { createRouter, createWebHistory, RouterView } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import KakaoAcademy from '@/views/KakaoAcademy.vue';
import ArticlePage from '@/views/ArticlePage.vue';
import NotFound from '@/views/NotFound.vue';
import { articleContent } from '@/data/articleContent';
import { articleMeta, hasArticleMeta, pageMeta } from '@/data/seo';
import { applyPageMeta } from '@/utils/seo';

// 404 без смены адреса в строке браузера: пользователь видит тот url,
// по которому пришёл.
const notFoundRoute = (to) => ({
  name: 'not-found',
  params: { pathMatch: to.path.replace(/^\//, '').split('/') },
});

// Статью показываем, только если для slug есть и контент в приложении, и
// нода в Drupal: без ноды адрес не существует и при прямом заходе, поэтому
// внутри приложения он ведёт себя так же.
const articleExists = (slug) =>
  Boolean(articleContent[slug]) && hasArticleMeta(slug);

const routes = [
  {
    path: '/',
    // Системный путь главной страницы в Drupal: при заходе по нему браузер
    // получает то же приложение, что и по адресу сайта.
    alias: '/home',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/kakao-academy',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'kakao-academy',
        component: KakaoAcademy,
      },
      {
        path: 'article/:slug',
        name: 'article',
        component: ArticlePage,
        // Статьи с неизвестным slug раньше отдавали пустую страницу —
        // показываем 404.
        beforeEnter: (to) =>
          articleExists(to.params.slug) ? true : notFoundRoute(to),
      },
    ],
  },
  // Любой неизвестный адрес внутри приложения.
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },
];

const router = createRouter({
  // Обычные адреса без «#». Базу задаём явно: значение по умолчанию берётся
  // из publicPath сборки, а он указывает на каталог со статикой модуля.
  // Чтобы адреса открывались напрямую, они есть и на стороне Drupal:
  // страницы — в ruchoko_front_landing.routing.yml, статьи — алиасами нод
  // по шаблону pathauto.
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// Canonical главной — корень сайта: /home это её системный путь в Drupal,
// такой же canonical стоит в исходной разметке.
const canonicalPath = (to) => (to.name === 'home' ? '/' : to.path);

// Теги обновляем после каждого перехода: в исходной разметке стоят теги той
// страницы, по адресу которой пользователь зашёл. Имена роутов совпадают
// с ключами страниц в ответе /api/seo/data — см. app/data/seo.js.
router.afterEach((to) => {
  const meta =
    to.name === 'article' ? articleMeta(to.params.slug) : pageMeta(to.name);

  applyPageMeta({ ...meta, canonical: canonicalPath(to) });
});

export default router;
